import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { CATALOG_CATEGORIES } from "@/data/catalog";
import { getJson } from "@/lib/api";
import { MaskLines, Reveal } from "@/components/MaskLines";
import { useLang } from "@/lib/i18n";

const Vitrine = ({ c, stats, i }) => {
  const { t } = useLang();
  return (
  <Reveal delay={0.06 * i}>
    <Link to={`/catalogo/revista?categoria=${c.id}`} className="vitrine group" data-testid={`vitrine-${c.id}`}>
      <div className="vitrine-case">
        <span className="vitrine-lamp" />
        <span className="vitrine-cone" />
        <img src={c.img} alt={t(`cat.${c.id}`)} className="vitrine-obj" loading="lazy" />
        <span className="vitrine-base" />
      </div>
      <div className="mt-4 flex items-start justify-between gap-3">
        <div>
          <h3 className="font-display text-2xl leading-tight">{t(`cat.${c.id}`)}</h3>
          <p className="mt-1 text-sm text-[var(--muted)]">{t(`cat.${c.id}.blurb`)}</p>
        </div>
        <ArrowRight size={18} className="mt-2 shrink-0 text-[var(--green)] transition-transform group-hover:translate-x-1" />
      </div>
      <div className="mono mt-3 flex gap-4 text-[11px]">
        <span className="text-[var(--muted)]" data-testid={`vitrine-count-${c.id}`}>{t("cat.pieces", { n: stats?.count ?? 0 })}</span>
        {stats?.owned > 0 && <span className="text-[var(--green)]" data-testid={`vitrine-owned-${c.id}`}>{t("cat.ownedN", { n: stats.owned })}</span>}
      </div>
    </Link>
  </Reveal>
  );
};

export default function Catalog() {
  const { t } = useLang();
  const [facets, setFacets] = useState(null);
  useEffect(() => { getJson("/catalog/facets").then(setFacets); }, []);
  const stat = (id) => (Array.isArray(facets?.categories) ? facets.categories.find((c) => c.id === id) : null);
  return (
    <main className="px-5 pb-28 pt-32 md:px-10" data-testid="catalog-page">
      <div className="mx-auto max-w-6xl">
        <p className="mono text-[11px] uppercase tracking-[0.22em] text-[var(--muted)]">{t("nav.catalog")}</p>
        <MaskLines as="h1" className="font-display mt-4 text-5xl leading-[0.95] sm:text-6xl lg:text-7xl" lines={[t("catp.l1"), <em key="e">{t("catp.l2")}</em>]} />
        <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
          <p className="max-w-2xl text-sm text-[var(--muted)] md:text-base">
            {t("catp.intro")}
          </p>
          <Link to="/catalogo/revista" className="btn-primary" data-testid="catalog-open-book-btn"><BookOpen size={16} /> {t("catp.open")}</Link>
        </div>
        <div className="mt-16 grid gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
          {CATALOG_CATEGORIES.map((c, i) => <Vitrine key={c.id} c={c} stats={stat(c.id)} i={i} />)}
        </div>
      </div>
    </main>
  );
}
